
import { Component, Vue } from 'vue-property-decorator';
// import { Action } from 'vuex-class';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import DropDown from '@/common/dropdown.vue';
import BackTop from '@/common/backtop.vue';
import NavMenu from '@/common/navmenu.vue';
// import {
//   refundType,
//   reasonList,
//   uploadFile,
//   addressList,
//   saveAddress
// } from '@/services/http';
// import { validateTelPhone } from '@/tools/regexp';
// import { readCookie } from '@/tools/tools';
// import addData from '../../assets/json/address.json';
@Component({
  components: {
    Header,
    Price,
    Footer,
    DropDown,
    BackTop,
    NavMenu
  }
})
export default class extends Vue {
  created() {}

  checkOrder() {
    this.$router.push('/exchange-list?status=0');
  }
}
